import React, { memo, useMemo, useRef } from 'react';

import { hasItem } from '@sravni/ugc/lib/specialOffers/helpers';
import { ACTIONS_LIST, VITRINS_OFFERS_LIST } from '@sravni/ugc/lib/specialOffers/lists';

import type { EventPayload } from '../../helpers/sendMessageToParentWindow';
import type { EnrichedOfferFromBff } from '../../interfaces/offers';
import { useActiveTabType } from '../../store/hooks/offers';
import type { TActionTypes } from '../../types/actions';

import { ActionBlock } from './components/HorizontalBlocks/ActionBLock';
import { OfferBlock } from './components/HorizontalBlocks/OfferBlock';

interface ICommonBlock {
  firstBlockRef: React.RefObject<HTMLAnchorElement>;
  isMobile: boolean;
  isPopup: boolean;
  handleEvent: (event: EventPayload) => void;
}

export interface IActionBlock extends ICommonBlock {
  item: TActionTypes;
}

export interface IOfferBlock extends ICommonBlock {
  item: EnrichedOfferFromBff;
}

export const Block = memo<IActionBlock | IOfferBlock>((props) => {
  const { firstBlockRef } = props;
  const activeTabType = useActiveTabType();

  const ref = useRef<HTMLAnchorElement>();
  const blockRef = useMemo(() => firstBlockRef ?? ref, [firstBlockRef]);

  // if (activeTabType === COMMON_OFFERS.mortgage) {
  //   return <MortgageBlock blockRef={blockRef} {...(props as IOfferBlock)} />;
  // }

  if (hasItem(VITRINS_OFFERS_LIST, activeTabType)) {
    return <OfferBlock blockRef={blockRef} {...(props as IOfferBlock)} />;
  }

  if (hasItem(ACTIONS_LIST, activeTabType)) {
    return <ActionBlock blockRef={blockRef} {...(props as IActionBlock)} />;
  }

  return null;
});
